const RNExitApp = {
  exitApp() {}
};

export default RNExitApp;
